import _baseUnary_default from "./_baseUnary.js";
import _nodeUtil_default from "./_nodeUtil.js";
import _baseIsSet_default from "./_baseIsSet.js";

//#region ../../node_modules/lodash-es/isSet.js
var nodeIsSet = _nodeUtil_default && _nodeUtil_default.isSet;
/**
* Checks if `value` is classified as a `Set` object.
*
* @static
* @memberOf _
* @since 4.3.0
* @category Lang
* @param {*} value The value to check.
* @returns {boolean} Returns `true` if `value` is a set, else `false`.
* @example
*
* _.isSet(new Set);
* // => true
*
* _.isSet(new WeakSet);
* // => false
*/
var isSet = nodeIsSet ? _baseUnary_default(nodeIsSet) : _baseIsSet_default;
var isSet_default = isSet;

//#endregion
export { isSet_default as default };
//# sourceMappingURL=isSet.js.map